<div *ngIf="reportConfig"
  style='margin-right: 18px;top:-17px'><powerbi-report powerbi-type="report" [embedConfig]="reportConfig"
    [eventHandlers]="eventHandlers"
    style="height: 800px; width: 100%;"></powerbi-report>
</div>